import type { EventsReadonly } from './DataLayer.types';

export const COMMON_EVENTS = {
  ACCOUNT_SELECTED_PATCH_ERROR: 'Account selected PATCH error',
  ACCOUNT_SELECTED_PAYMENT_DETAILS_UNDEFINED_WHILE_PATCH:
    'Account selected - payment details undefined while PATCH',
  ACCOUNT_SELECTED: 'Account selected',
  APP_IS_LOADING: 'App is loading',
  ADDITIONAL_REQUIREMENTS_PROVIDED: 'Additional requirements provided',
  ADDITIONAL_REQUIREMENTS_VALIDATION_ERROR:
    'Additional Requirements validation error',
  BANK_REDIRECT_FALLBACK_BANNER_VIEW: 'Bank redirect fallback banner displayed',
  BANK_REDIRECT_SCREEN: 'Bank redirect screen view',
  BANK_SEARCHED: 'Bank name searched',
  BANK_SELECT: 'Bank select',
  BANK_NOT_FOUND_MODAL_OPENED: 'Bank not found modal opened',
  CANCEL_CLICK: 'Cancel click',
  CANCEL_ERROR: 'API Error occured during payment cancellation',
  CANCEL_SCREEN: 'Payment cancel screen view',
  CANCEL_SKIP: 'Cancel modal skipped',
  CHECKOUT_IS_LOADING: 'Checkout is loading',
  CONTINUE_ON_THE_WELCOME_SCREEN_CLICK: 'Continue on the Welcome screen click',
  ERROR_SCREEN: 'Error screen view',
  FAILURE_SCREEN: 'Payment failure screen view',
  GO_BACK_FROM_MOBILE_TO_SUMMARY:
    'Go back from Continue on mobile to Summary view click',
  LANGUAGE_CHANGE: 'Language change',
  PAGE_VISIT_OPEN_BANKING: 'Open banking page visit',
  PAY_AT_MY_BANK_DISPLAYED: 'Pay at my bank displayed',
  PAY_AT_MY_BANK_CLICK: 'Pay at my bank click',
  PENDING_SCREEN: 'Payment pending screen view',
  QR_CODE_DISPLAYED: 'QR code displayed',
  SUCCESS_SCREEN: 'Payment success screen view',
  SUMMARY_SCREEN: 'Payment summary screen view',
  TERMS_AND_CONDITIONS_CLICK: 'Terms and conditions click',
  REDIRECTION: 'Redirection',
  COUNTRY_CHANGE: 'Country change',
  COPY_BANK_REDIRECT_LINK_CLICK: 'Copy bank redirect link click',
  BANK_SELECT_NO_INSTITUTION_LIST: 'Bank list not available',
  HEADER_BACK_BUTTON: 'Click on header back button',
  BANK_GROUP_CLICKED: 'Bank group clicked',
  LOAD_MORE_BUTTON_CLICK: 'Load more button clicked',
  BANKS_FAILED_TO_LOAD: 'Banks failed to load view',
  BANK_SEARCH_CLEAR: 'Bank search input cleared',
  RELOAD_CLICK: 'Reload institutions click',
} as const satisfies EventsReadonly;
